import httpAuth from "@/common/http-common";
import { 
  SowsAssessment, 
  DoseTime,
  WatchWorn,
  WatchCharging,
  UpsertDosageResponse,
  ParticipantPayment,
  ResearchRewards,
  UpsertPaymentHistory,
  PaymentStatus,
  BiometricCollectionCount,
  AppointmentStatus,
  UpsertAppointmentStatus,
  AssessmentSummary
} from "@/views/sidebar/research-data/research-data.types";
import { AlertZone } from "@/views/dashboard/dashboard.types";

class ResearchDataService {
  async getAlertZones(alertZoneType: number, clientId: number) {
    const { data } = await httpAuth().get<AlertZone[]>(
      '/Dashboard/GetAlertZones', { params: { 
        alertZoneType: alertZoneType,
        clientId: clientId
      } 
    });
    return data;
  }

  async GetSowsAssessments(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<SowsAssessment[]>(
      '/ResearchData/GetSowsAssessments', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetDoseTimes(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<DoseTime[]>(
      '/ResearchData/GetDoseTimes', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetAppointmentStatus(clientId: number, date: string, participantId: number) {
    const { data } = await httpAuth().get<AppointmentStatus[]>(
      '/ResearchData/GetAppointmentStatus', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
      } 
    });
    return data;
  }

  async GetWatchWorn(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<WatchWorn>(
      '/ResearchData/GetWatchWorn', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetWatchCharging(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<WatchCharging>(
      '/ResearchData/GetWatchCharging', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetBiometricRecordCount(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<BiometricCollectionCount>(
      '/WatchStatistics/GetBiometricRecordCount', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async UpsertDosageResponse(upsertDosageResponse: UpsertDosageResponse) {
    const { data } = await httpAuth().post(
      `/ResearchData/UpsertDosageResponse`, 
      upsertDosageResponse 
    );
    return data;
  }

  async UpsertAppointmentStatus(upsertAppointmentStatus: UpsertAppointmentStatus) {
    const { data } = await httpAuth().post(
      `/ResearchData/UpsertAppointmentStatus`, 
      upsertAppointmentStatus 
    );
    return data;
  }

  async CalculateParticipantPayment(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<ParticipantPayment>(
      '/ResearchData/CalculateParticipantPayment', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetParticipantPaymentSummary(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<ResearchRewards[]>(
      '/ResearchData/GetParticipantPaymentSummary', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async UpsertPaymentHistory(upsertPaymentHistory: UpsertPaymentHistory) {
    const { data } = await httpAuth().post(
      `/ResearchData/UpsertPaymentHistory`, 
      upsertPaymentHistory 
    );
    return data;
  }

  async GetParticipantPaymentStatus(clientId: number, date: string, participantId: number) {
    const { data } = await httpAuth().get<PaymentStatus>(
      '/ResearchData/GetParticipantPaymentStatus', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId
      } 
    });
    return data;
  }

  async GetAssessmentSummary(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<AssessmentSummary[]>(
      '/ResearchData/GetAssessmentSummary', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }
}

export default new ResearchDataService();